import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  id: "transferGtrPointsModal"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col d-flex justify-content-center" }
const _hoisted_9 = { class: "ms-2 text-nowrap" }
const _hoisted_10 = { class: "row mb-4" }
const _hoisted_11 = { class: "input-group d-flex w-100 mb-4" }
const _hoisted_12 = {
  class: "form-floating",
  style: {"flex":"1"}
}
const _hoisted_13 = {
  key: 0,
  class: "alert alert-info text-center",
  role: "alert"
}
const _hoisted_14 = { class: "row mb-4" }
const _hoisted_15 = { class: "col mx-4" }
const _hoisted_16 = {
  key: 0,
  class: "row"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "row mb-3" }
const _hoisted_19 = { class: "col-12 mb-2" }
const _hoisted_20 = { class: "form-control border-0 p-0" }
const _hoisted_21 = { class: "form-floating" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "invalid-feedback ms-3" }
const _hoisted_24 = { class: "col-12" }
const _hoisted_25 = { class: "form-floating" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "row"
}
const _hoisted_32 = {
  key: 2,
  class: "row"
}
const _hoisted_33 = { class: "col" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "d-flex justify-content-between px-4" }
const _hoisted_36 = {
  key: 2,
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_37 = {
  key: 1,
  class: "text-warning text-center fs-5 m-4 lh-lg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_simple_view = _resolveComponent("user-simple-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "modal-title" }, [
            _createElementVNode("i", { class: "fas fa-share fa-fw me-2" }),
            _createTextVNode("Transferir GTR Points ")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-sm",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.isActive)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "fw-bold" }, "GTR Points Disponibles: ", -1)),
                    _createElementVNode("span", _hoisted_9, "G$ " + _toDisplayString(_ctx.totalString), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control",
                        placeholder: "Buscar Socio",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchUserValue) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.searchUserValue,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _cache[13] || (_cache[13] = _createElementVNode("label", { for: "floatingInput" }, "Buscar Socio", -1))
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-secondary",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchUser && _ctx.searchUser(...args)))
                    }, "Buscar")
                  ])
                ]),
                (_ctx.searching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [...(_cache[14] || (_cache[14] = [
                      _createElementVNode("i", { class: "fas fa-cog fa-fw fa-spin me-1" }, null, -1),
                      _createTextVNode("Buscando usuario...", -1)
                    ]))]))
                  : (!_ctx.searching && _ctx.user !== undefined)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_user_simple_view, { user: _ctx.user }, null, 8, ["user"])
                          ])
                        ]),
                        (!_ctx.processing && !_ctx.processResponse)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["input-group", { 'is-invalid': _ctx.invalidAmount }]),
                                      id: "amount-to-transfer-group"
                                    }, [
                                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "input-group-text px-4" }, "G$", -1)),
                                      _createElementVNode("span", _hoisted_20, [
                                        _createElementVNode("span", _hoisted_21, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control fw-bold pt-2 fs-5 text-end rounded-0",
                                            id: "amount-to-transfer",
                                            placeholder: "Cantidad a Transferir",
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.amountString) = $event)),
                                            disabled: _ctx.searching || _ctx.processing,
                                            onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateInteger($event))),
                                            onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.touchAmount && _ctx.touchAmount(...args))),
                                            inputmode: "numeric"
                                          }, null, 40, _hoisted_22), [
                                            [
                                              _vModelText,
                                              _ctx.amountString,
                                              void 0,
                                              { trim: true }
                                            ]
                                          ]),
                                          _cache[15] || (_cache[15] = _createElementVNode("label", {
                                            for: "amount-to-transfer",
                                            class: "opacity-100 moz-mt-3 text-nowrap"
                                          }, [
                                            _createElementVNode("span", null, "Cantidad a Transferir")
                                          ], -1))
                                        ])
                                      ]),
                                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "input-group-text ps-2 pe-4" }, ".00", -1))
                                    ], 2),
                                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.invalidAmountError), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("span", _hoisted_25, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control", { 'is-invalid': _ctx.conceptError }]),
                                        name: "transfer-concept",
                                        id: "transfer-concept",
                                        placeholder: "Concepto",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.concept) = $event)),
                                        disabled: _ctx.searching || _ctx.processing,
                                        onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.touchConcept && _ctx.touchConcept(...args)))
                                      }, null, 42, _hoisted_26), [
                                        [
                                          _vModelText,
                                          _ctx.concept,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      _cache[18] || (_cache[18] = _createElementVNode("label", {
                                        for: "amount-to-transfer",
                                        class: "opacity-100 moz-mt-3 text-nowrap"
                                      }, [
                                        _createElementVNode("span", null, "Concepto")
                                      ], -1)),
                                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "invalid-feedback ms-3" }, " El \"Concepto\" es requerido. ", -1))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("div", _hoisted_29, [
                                      _createElementVNode("button", {
                                        class: "form-control btn btn-outline-primary w-50",
                                        type: "button",
                                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.transferPoints && _ctx.transferPoints(...args))),
                                        disabled: !_ctx.canTransfer || _ctx.searching || _ctx.processing
                                      }, " Transferir ", 8, _hoisted_30)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : (_ctx.processing && !_ctx.processResponse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[20] || (_cache[20] = [
                                _createElementVNode("div", { class: "col" }, [
                                  _createElementVNode("div", {
                                    class: "alert alert-info text-center",
                                    role: "alert"
                                  }, [
                                    _createElementVNode("i", { class: "fas fa-cog fa-fw fa-spin me-1" }),
                                    _createTextVNode("Procesando...")
                                  ])
                                ], -1)
                              ]))]))
                            : (!_ctx.processing && _ctx.processResponse)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(["alert text-center", _ctx.processError ? 'alert-danger' : 'alert-success']),
                                      role: "alert"
                                    }, [
                                      _createElementVNode("div", { innerHTML: _ctx.processMessage }, null, 8, _hoisted_34)
                                    ], 2),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("button", {
                                        class: "btn btn-outline-secondary",
                                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.close())),
                                        "data-bs-dismiss": "modal"
                                      }, "Cerrar"),
                                      _createElementVNode("button", {
                                        class: "btn btn-outline-primary",
                                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.newTransfer && _ctx.newTransfer(...args)))
                                      }, "Otra Transferencia")
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                      ], 64))
                    : (!_ctx.searching && _ctx.error !== '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.error), 1))
                      : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_37, [...(_cache[21] || (_cache[21] = [
                _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-2" }, null, -1),
                _createTextVNode(" Para poder transferir ", -1),
                _createElementVNode("span", { class: "text-danger" }, "GTR Points", -1),
                _createTextVNode(", necesitas estar ", -1),
                _createElementVNode("span", { class: "text-danger fw-bold" }, "ACTIVO", -1),
                _createTextVNode(" en academia.", -1),
                _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw ms-2" }, null, -1)
              ]))]))
        ])
      ])
    ])
  ]))
}